var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.0743 9.98239C16.3407 9.66523 16.2996 9.19214 15.9824 8.92572C15.6652 8.6593 15.1921 8.70044 14.9257 9.01761L12.8257 11.5176C12.5914 11.7965 12.5914 12.2035 12.8257 12.4824L14.9257 14.9824C15.1921 15.2996 15.6652 15.3407 15.9824 15.0743C16.2996 14.8079 16.3407 14.3348 16.0743 14.0176L15.0095 12.75H18.5C18.9142 12.75 19.25 12.4142 19.25 12C19.25 11.5858 18.9142 11.25 18.5 11.25H15.0095L16.0743 9.98239ZM8.74104 8.9806C8.45418 8.68179 7.97941 8.6721 7.6806 8.95896C7.38179 9.24582 7.3721 9.72059 7.65896 10.0194L8.84034 11.25H5.5C5.08579 11.25 4.75 11.5858 4.75 12C4.75 12.4142 5.08579 12.75 5.5 12.75H8.99051L7.92572 14.0176C7.6593 14.3348 7.70044 14.8079 8.01761 15.0743C8.33477 15.3407 8.80786 15.2996 9.07428 14.9824L11.1743 12.4824C11.4207 12.189 11.4064 11.757 11.141 11.4806L8.74104 8.9806Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompress);
export default __webpack_public_path__ + "static/media/compress.a7d480ea4fa9f4d6f32e343c7145b67d.svg";
export { ForwardRef as ReactComponent };